<template>
  <div class="medicine-edit">
    <page-layout>
      <!-- <div class="medicine-edit__header">
        <div class="medicine-edit__title">{{ isEdit ? '编辑' : '新建' }}用药人</div>
      </div> -->
      <div class="medicine-edit__tips">
        <van-icon name="info" />
        <span>处方药需实名购药，平台严格保护用药人隐私</span>
      </div>
      <div class="medicine-edit__content">
        <div class="medicine-edit__form">
          <div class="medicine-edit__form-item">
            <div class="medicine-edit__form-label"><span class="required">*</span>姓名</div>
            <div class="medicine-edit__form-input">
              <input type="text" v-model="form.name" placeholder="请输入姓名" />
            </div>
          </div>
          <div class="medicine-edit__form-item">
            <div class="medicine-edit__form-label"><span class="required">*</span>手机号</div>
            <div class="medicine-edit__form-input">
              <input type="tel" v-model="form.phone" maxLength="11" placeholder="请输入手机号" />
            </div>
          </div>
          <div class="medicine-edit__form-item">
            <div class="medicine-edit__form-label"><span class="required">*</span>身份证号</div>
            <div class="medicine-edit__form-input">
              <input type="text" v-model="form.idCard" placeholder="请输入身份证号" />
            </div>
          </div>
          <div class="medicine-edit__form-item" v-if="showWeightField">
            <div class="medicine-edit__form-label"><span v-if="isWeightRequired" class="required">*</span>体重</div>
            <div class="medicine-edit__form-input">
              <input type="number" v-model="form.weight" placeholder="请输入体重(kg)" />
            </div>
          </div>
          <div class="medicine-edit__form-item" @click="toggleHealthInfo">
            <div class="medicine-edit__form-label">健康信息</div>
            <div class="medicine-edit__form-value">
              <span>{{ formatMedicalHistory(form.healthInfo) || '请填写' }}</span>
              <i class="iconfont icon-arrow" :class="{ 'icon-arrow-up': showHealthInfo }"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="medicine-edit__relation">
        <div class="medicine-edit__relation-title">关系标签</div>
        <div class="medicine-edit__relation-tags">
          <div
            v-for="item in relationTags"
            :key="item.label"
            class="medicine-edit__relation-tag"
            :class="{ active: form.relation === item.label }"
            @click="form.relation = item.label"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </page-layout>
    <health-info v-model="showHealthInfo" :health-data="form.healthInfo" @submit="handleHealthInfoSubmit" />
    <fixed-button text="保存" @emitEvent="handleSubmit" />
  </div>
</template>

<script>
import { Icon as VanIcon } from 'vant';
import FixedButton from '@/components/fixedButton';
import HealthInfo from './components/healthInfo';
import services from '@/service';
import eventBus from '@/lib/eventBus';

export default {
  name: 'mallMedicineEdit',
  components: {
    VanIcon,
    FixedButton,
    HealthInfo
  },
  data() {
    return {
      isEdit: false,
      showHealthInfo: false,
      form: {
        name: '',
        idCard: '',
        phone: '',
        weight: '',
        healthInfo: {
          pmhType: { has: false, selected: [], remark: '' },
          drugAllergyType: { has: false, selected: [], remark: '' },
          foodAllergyType: { has: false, selected: [], remark: '' },
          contactAllergyType: { has: false, selected: [], remark: '' },
          fmhType: { has: false, selected: [], remark: '' },
          liverType: 0,
          renalType: 0,
          nurseType: { has: false, selected: [] }
        },
        relation: '本人'
      },
      relationTags: [
        { label: '本人', value: 'self' },
        { label: '家庭成员', value: 'family' },
        { label: '亲戚', value: 'relative' },
        { label: '朋友', value: 'friend' }
      ]
    };
  },
  computed: {
    healthInfoText() {
      const info = this.form.healthInfo;
      const texts = [];

      // 处理病史和过敏史
      const sections = ['pmhType', 'drugAllergyType', 'foodAllergyType', 'contactAllergyType', 'fmhType'];
      sections.forEach(key => {
        if (info[key].has && info[key].selected.length) {
          texts.push(info[key].selected.join(','));
        }
      });

      // 处理肝功能和肾功能
      if (info.liverType === 1) {
        texts.push('肝功能异常');
      }
      if (info.renalType === 1) {
        texts.push('肾功能异常');
      }

      // 处理妊娠哺乳
      if (info.nurseType.has && info.nurseType.selected.length) {
        texts.push(info.nurseType.selected[0]);
      }

      return texts.length ? texts.join('，') : '';
    },
    age() {
      if (!this.form.idCard) return 0;
      const idCard = this.form.idCard;
      const birthYear = parseInt(idCard.substring(6, 10));
      const birthMonth = parseInt(idCard.substring(10, 12));
      const birthDay = parseInt(idCard.substring(12, 14));

      const today = new Date();
      const currentYear = today.getFullYear();
      const currentMonth = today.getMonth() + 1;
      const currentDay = today.getDate();

      let age = currentYear - birthYear;
      if (currentMonth < birthMonth || (currentMonth === birthMonth && currentDay < birthDay)) {
        age--;
      }
      return age;
    },
    showWeightField() {
      return this.age <= 14 && this.form.idCard;
    },
    isWeightRequired() {
      return this.showWeightField;
    }
  },
  created() {
    const { id } = this.$route.params;
    if (id) {
      this.isEdit = true;
      this.getMedicineDetail(id);
    }
  },
  methods: {
    async getMedicineDetail(id) {
      try {
        const { data } = await services.mall.patientrelDetail(id);
        const healthFields = ['pmh', 'drugAllergy', 'foodAllergy', 'contactAllergy', 'fmh'];
        const healthInfo = healthFields.reduce(
          (acc, field) => {
            const fieldType = `${field}Type`;
            const fieldDesc = field === 'pmh' || field === 'fmh' ? field : `${field}Desc`;
            acc[`${field}Type`] = {
              has: data[`${fieldType}`] === 1,
              selected: data[`${fieldDesc}`] ? data[`${fieldDesc}`].split(',') : [],
              remark: ''
            };
            return acc;
          },
          {
            liverType: data.liverType,
            renalType: data.renalType,
            nurseType: {
              has: data.nurseType === 1,
              selected: data.nurseDesc ? [data.nurseDesc] : []
            }
          }
        );

        this.form = {
          name: data.name,
          idCard: data.idCard,
          phone: data.phone,
          healthInfo,
          relation: data.relTag
        };
      } catch (error) {
        this.$toast('获取用药人信息失败');
      }
    },
    toggleHealthInfo() {
      this.showHealthInfo = !this.showHealthInfo;
    },
    handleHealthInfoSubmit(healthInfo) {
      this.form.healthInfo = healthInfo;
      this.showHealthInfo = false;
    },
    async handleSubmit() {
      // 重置错误状态
      const formItems = document.querySelectorAll('.medicine-edit__form-item');
      formItems.forEach(item => item.classList.remove('error'));
      if (!this.form.name) {
        this.$toast('请输入真实姓名');
        formItems[0].classList.add('error');
        return;
      }
      if (!this.form.phone) {
        this.$toast('请输入手机号');
        formItems[1].classList.add('error');
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.$toast('请输入正确的手机号');
        formItems[1].classList.add('error');
        return;
      }
      if (!this.form.idCard) {
        this.$toast('请输入身份证号');
        formItems[2].classList.add('error');
        return;
      }
      if (!/^[1-9]\d{5}(19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/.test(this.form.idCard)) {
        this.$toast('请输入正确的身份证号');
        formItems[2].classList.add('error');
        return;
      }

      // 添加体重验证
      if (this.showWeightField && !this.form.weight) {
        this.$toast('14岁以下儿童请输入体重');
        formItems[3].classList.add('error');
        return;
      }

      const params = {
        name: this.form.name,
        idCard: this.form.idCard,
        phone: this.form.phone,
        weight: this.showWeightField ? this.form.weight : '',
        relTag: this.form.relation
      };
      const healthInfo = { ...this.form.healthInfo };
      Object.keys(healthInfo).forEach(key => {
        const fieldName = key.replace(/Type$/, '');

        if (typeof healthInfo[key] === 'object') {
          const has = healthInfo[key].has ? 1 : 0;
          if (fieldName === 'pmh' || fieldName === 'fmh') {
            params[`${fieldName}Type`] = has;
            if (has) {
              params[fieldName] = healthInfo[key].selected.join(',');
            }
          } else {
            params[`${fieldName}Type`] = has;
            if (has) {
              params[`${fieldName}Desc`] = healthInfo[key].selected.join(',');
            }
          }
        } else {
          params[key] = healthInfo[key];
          params[`${fieldName}Desc`] = '-';
        }
      });

      if (this.isEdit) {
        params.patientRelId = this.$route.params.id;
        await services.mall.patientrelEdit(params);
      } else {
        await services.mall.patientrelAdd(params);
      }
      this.$toast('保存成功');
      eventBus.$emit('medicine-updated');
      this.$router.back();
    },
    formatMedicalHistory(history) {
      if (!history) return '';
      const result = [];

      // 处理所有病史类型
      const types = {
        pmhType: '过往病史',
        fmhType: '家族遗传病史',
        drugAllergyType: '药物过敏史',
        foodAllergyType: '食物过敏史',
        contactAllergyType: '接触过敏史'
      };

      // 处理病史和过敏史
      Object.entries(types).forEach(([key, label]) => {
        if (history[key]?.has && history[key]?.selected?.length) {
          result.push(`${label}：${history[key].selected.join('、')}`);
        }
      });

      // 处理肝肾功能
      if (history.liverType === 1) result.push('肝功能异常');
      if (history.renalType === 1) result.push('肾功能异常');

      // 处理妊娠哺乳
      if (history.nurseType?.has && history.nurseType?.selected?.length) {
        result.push(`妊娠哺乳：${history.nurseType.selected[0]}`);
      }

      return result.join('，');
    }
  }
};
</script>

<style lang="scss" scoped>
.required {
  color: #ff4d4f;
  margin-right: 4px;
  font-family: SimSun, sans-serif;
}
.medicine-edit {
  background: #f7f8fa;

  &__header {
    padding: 20px 16px;
    background: #fff;
  }

  &__tips {
    margin: 12px 16px;
    padding: 14px 16px;
    background: #fff9f3;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #ff6b35;
    border-radius: 8px;

    .van-icon {
      font-size: 16px;
      margin-right: 8px;
    }
  }

  &__title {
    font-size: 18px;
    font-weight: 500;
    color: #333;
  }

  &__form {
    background: #fff;
    padding: 16px;
    margin: 12px 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    &-item {
      display: flex;
      align-items: center;
      min-height: 52px;
      border-bottom: 1px solid #f5f5f5;

      &.error {
        border-bottom-color: #ff4d4f;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    &-label {
      width: 90px;
      font-size: 15px;
      color: #323233;
      font-weight: 500;
    }

    &-input {
      flex: 1;

      input {
        width: 100%;
        height: 24px;
        border: none;
        outline: none;
        font-size: 15px;
        color: #323233;

        &::placeholder {
          color: #969799;
          font-size: 14px;
        }
      }
    }

    &-value {
      flex: 1;
      display: flex;
      align-items: flex-start;
      justify-content: flex-end;
      color: #666;
      font-size: 14px;
      min-height: 24px;
      padding: 14px 0;

      span {
        flex: 1;
        text-align: right;
        margin-right: 4px;
        word-break: break-all;
        line-height: 1.4;
      }

      .iconfont {
        flex: none;
        margin-top: 3px;
        font-size: 12px;
        transition: transform 0.3s;

        &.icon-arrow-up {
          transform: rotate(180deg);
        }
      }
    }
  }

  &__relation {
    margin: 12px 16px;
    background: #fff;
    padding: 16px;
    border-radius: 8px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

    &-title {
      font-size: 15px;
      color: #323233;
      font-weight: 500;
      margin-bottom: 16px;
    }

    &-tags {
      display: flex;
      flex-wrap: wrap;
      margin: -4px;
    }

    &-tag {
      margin: 4px;
      padding: 8px 16px;
      border-radius: 6px;
      font-size: 14px;
      color: #666;
      background: #f7f8fa;
      transition: all 0.3s ease;

      &.active {
        color: $appcolor;
        background: rgba($appcolor, 0.1);
      }
    }
  }
}
</style>
